// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar-X1Y79","help":"help-XKJGG"};